import { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Packages', href: '#packages' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'FAQ', href: '#faq' },
    { label: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-zinc-950/90 backdrop-blur-xl border-b border-white/5 shadow-2xl'
          : 'bg-transparent'
      }`}
    >
      {/* Top bar */}
      <div className={`transition-all duration-300 overflow-hidden ${
        isScrolled ? 'max-h-0 opacity-0' : 'max-h-10 opacity-100'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-2 flex justify-end items-center gap-6 text-xs text-zinc-400">
          <a href={`tel:${businessInfo.contact.phones[0].replace(/\s/g, '')}`} className="flex items-center gap-1.5 hover:text-[#50ced4] transition-colors">
            <Phone className="w-3 h-3" />
            {businessInfo.contact.phones[0]}
          </a>
          <a href={`mailto:${businessInfo.contact.email}`} className="flex items-center gap-1.5 hover:text-[#50ced4] transition-colors">
            <Mail className="w-3 h-3" />
            {businessInfo.contact.email}
          </a>
        </div>
      </div>

      {/* Main nav */}
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        {/* Logo */}
        <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center gap-2 group">
          <img
            src={businessInfo.logo}
            alt="Sound Hire Tarneit"
            className="h-12 w-auto object-contain rounded-lg"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="px-4 py-2 text-sm text-zinc-300 hover:text-white rounded-lg hover:bg-white/5 transition-all duration-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href={`tel:${businessInfo.contact.phones[0].replace(/\s/g, '')}`}
            className="ml-3"
          >
            <Button className="bg-[#50ced4] hover:bg-[#3eb8be] text-zinc-950 font-semibold px-5 rounded-lg text-sm">
              <Phone className="w-4 h-4 mr-2" />
              Call Now
            </Button>
          </a>
        </nav>

        {/* Mobile menu button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden text-white p-2 rounded-lg hover:bg-white/10 transition-colors"
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="px-6 pb-6 flex flex-col gap-1 bg-zinc-950/95 backdrop-blur-xl">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="px-4 py-3 text-sm text-zinc-300 hover:text-white rounded-lg hover:bg-white/5 transition-all duration-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href={`tel:${businessInfo.contact.phones[0].replace(/\s/g, '')}`}
            className="mt-2"
          >
            <Button className="w-full bg-[#50ced4] hover:bg-[#3eb8be] text-zinc-950 font-semibold rounded-lg">
              <Phone className="w-4 h-4 mr-2" />
              Call Now
            </Button>
          </a>
        </nav>
      </div>
    </header>
  );
};
